import React, { useState } from 'react'
import pre from './Pre.module.css'
import { MdOutlineDashboard } from 'react-icons/md'
import { CiSearch, CiSettings } from 'react-icons/ci'
import { LuFileSliders } from 'react-icons/lu'
import { format } from 'date-fns';
import imgi from '../../../img/img12.png'
import imgii from '../../../img/img13.png'
import imgiii from '../../../img/img14.png'
import { BsDot } from 'react-icons/bs'
import { Link } from 'react-router'
const PreviewOne = () => {
    const [Search, setSearch] = useState('')


        const dates = new Date();

        const showTime = dates.toLocaleString([], {
              hour: "2-digit",
              minute: "2-digit",
        });
        
  return (
    <div className={pre.pre}>
      <div className={pre.container}>
        <div className={pre.content}>
            <div className={pre.block}>
                <div className={pre.blocki}>
                <div className={pre.seci}>
                            <div className={pre.icon}>
                                <MdOutlineDashboard />
                                
                                <h3>Dashboard</h3>
                            </div>
                            <div className={pre.icon}>
                                <LuFileSliders />
                                <h3>Article Review</h3>
                            </div>
                        </div>
                        <div className={pre.seciI}>
                            <div className={pre.icon}>
                                <CiSettings />
                                <h3>Settings</h3>
                            </div>
                            <div className={pre.icon}>                               
                                <h3>Logout</h3>
                            </div>
                        </div>
                </div>
                <div className={pre.blockIII}>
                <div className={pre.blockii}>
                        <div className={pre.dash}>
                            <h2>Articles</h2>
                            <div className={pre.dashi}>
                                <input 
                                type="search" 
                                name="search" id="search" 
                                placeholder='Search for article'
                                onChange={(e)=> setSearch(e.target.value)}/>
                                <CiSearch />

                            </div>
                        </div>
                </div>
                <div className={pre.blockI}>
                
                    <div className={pre.Blocki}>
                       
                <div className={pre.blockiii}>
                    <div className={pre.blockII}>
                        <h5>Review</h5>
                        <p>These are the articles expected to be 
                            review, each articles are based on FILO </p>
                        <div className={pre.card}>
                            <img src={imgiii} alt=""  />
                            <button className={pre.btn}>World news</button>
                            <h3>Transgender protest against Donald trump’s 
                            administration in Washington </h3>
                            <p>
                                The transgender society of Washington USA has been seen protesting against 
                                the administration of Trump. Ever since the newly elected United state of 
                                America has been official announced as the president of UNITED STATE, the 
                                transgender association has been seen protesting against it. One of the 
                                representative of this campaign said “it was a rigged election given that Trump 
                                was emerged the winner of the the election”.
                            </p>
                            <Link to='/PublisherLogin/Previewpage/PublishReview/frist-page' state={{ source: "A" }}><button className={pre.Btn}>Preview Article</button></Link>
                            
                        </div>
                    </div>
                </div>
                    </div>
                    <div className={pre.Blockii}>
                        <h4>Recent</h4>
                        <div className={pre.cardi}>
                            <button className={pre.btn}>world news</button>
                            <h3>Trump embarks on a journey to Russia to 
                                discuss new alliances with president 
                            Vladmir Putin</h3>
                            <p>
                            The transgender society of Washington USA has been seen protesting against the administration of Trump. 
                            Ever since the newly elected United state of America has been official announced as the president of USA
                            the transgender association has been seen protesting against it. One of the protester of this campaign said 
                            “it was a rigged election given that Trump was emerged the winner of the the election”.
                            </p>
                            <div className={pre.inline}>
                                <div className={pre.flex}>
                                <h5>{showTime}</h5>
                                <BsDot />
                                <h5 className={pre.Date}>{format(new Date() , "d , MMM yyyy")}</h5>
                                <BsDot />
                                <h5>Author: Adebisi Samuel</h5>
                                </div>
                                <Link to='/PublisherLogin/Previewpage/PublishReview/second-page' state={{ source: "B" }}><h4 className={pre.para}>Status: Decline</h4></Link>
                                
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                

            </div>
        </div>
      </div>
    </div>
  )
}

export default PreviewOne
